import React from 'react';
// duperbrowse context, for internal use only
export const DuperbrowseStreamContext = React.createContext({
    stream: {
        items: [],
        streamId: ''
    },
    loadDuperbrowse: ()=>null
});
DuperbrowseStreamContext.displayName = 'DuperbrowseStreamContext';

//# sourceMappingURL=DuperbrowseStreamContext.js.map